import React from 'react';

import OrgSettingLayout from '@views/Organization/OrgSettingManagementLayout';
import UserManagement from '@views/Organization/Setting/UserManagement';

export default function UserManagementMainPage(
  props: PagePropsWithBreadcrumbs
) {
  return (
    <OrgSettingLayout pageProps={props}>
      {({ account_id, is_within_org }) => (
        <UserManagement account_id={account_id} is_org={is_within_org} />
      )}
    </OrgSettingLayout>
  );
}
